import React from 'react';

import AttachmentTop from './AttachementTop';
import Brands from './Brands';
import Categories from './Categories';
import Information from './Information';
import Regions from './Regions';

import { Row, T8y } from 'ui';

import style from './footer.module.scss';

const currentYear = new Date().getFullYear();

export const Footer = () => {
  return (
    <footer>
      <AttachmentTop />
      <Row
        justify="center"
        smDirection="column"
        className={style.footerAttachmentContainer}
      >
        <div className={style.footerColumn}>
          <Categories />
        </div>
        <div className={style.footerColumn}>
          <Information />
        </div>
        <div className={style.footerColumn}>
          <Regions />
        </div>
        <div className={style.footerColumn} />
      </Row>
      <Brands />

      <div className={style.copyright}>
        <T8y variant="t1v1" mt>
          Copyright © {currentYear} easySkip. All rights reserved. Company
          number 16286583
        </T8y>
      </div>
    </footer>
  );
};
